<div *ngIf="!isProduction" class="bg-primary  text-white text-center" style="width: 100% ; z-index: 10001">
    Test Mode
</div>
<router-outlet></router-outlet>
